import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import apiService from "../backend/api";

const useSubscription = (username) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["subscription", username],
    queryFn: async () => {
      if (!username) return null;
      const data = await apiService.getUserSubscriptions(username);
      return data;
    },
    enabled: !!username,
    staleTime: 1000 * 60 * 10, // 10 minutes
  });

  const cancelMutation = useMutation({
    mutationFn: async () => {
      // Use request directly if no specific method exists, but apiService seems to have generic request
      // Based on ProfileSubscription.jsx: apiService.request(`${getBaseUrl()}/api/payment/cancel-subscription`, ...)
      // Let's assume we want a cleaner API method if possible, or just use a wrapper.
      // For now, let's keep it simple.
      return apiService.request('/api/payment/cancel-subscription', {
        method: 'POST',
        body: JSON.stringify({ username }),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["subscription", username]);
    },
  });

  return {
    ...query,
    cancelSubscription: cancelMutation.mutate,
    isCancelling: cancelMutation.isPending,
  };
};

export default useSubscription;
